export default __webpack_public_path__ + "static/media/icoPayment.44e8d242.svg";